export default "__VITE_ASSET__hNJQVJXK__"